export const EXECUTION_URL = 'bpmn-execution';
export const BP_MODEL_URL = 'bp-model';
